// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignOutRouteImport } from './routes/sign-out'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAccountRouteImport } from './routes/admin/account'
import { Route as AdminPlayersRouteImport } from './routes/admin/players'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminSponsorRouteImport } from './routes/admin/sponsor'
import { Route as AuthConfirmRouteImport } from './routes/auth/confirm'
import { Route as AdminGamesGameIdRouteImport } from './routes/admin/games/$gameId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const SignOutRoute = SignOutRouteImport.update({
            id: '/sign-out',path: '/sign-out',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminAccountRoute = AdminAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AdminRoute
          })
const AdminPlayersRoute = AdminPlayersRouteImport.update({
            id: '/players',path: '/players',getParentRoute: () => AdminRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRoute
          })
const AdminSponsorRoute = AdminSponsorRouteImport.update({
            id: '/sponsor',path: '/sponsor',getParentRoute: () => AdminRoute
          })
const AuthConfirmRoute = AuthConfirmRouteImport.update({
            id: '/auth/confirm',path: '/auth/confirm',getParentRoute: () => rootRouteImport
          })
const AdminGamesGameIdRoute = AdminGamesGameIdRouteImport.update({
            id: '/games/$gameId',path: '/games/$gameId',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminAccountRoute: AdminAccountRoute,AdminPlayersRoute: AdminPlayersRoute,AdminSettingsRoute: AdminSettingsRoute,AdminSponsorRoute: AdminSponsorRoute,AdminIndexRoute: AdminIndexRoute,AdminGamesGameIdRoute: AdminGamesGameIdRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,ForgotPasswordRoute: ForgotPasswordRoute,ResetPasswordRoute: ResetPasswordRoute,SignInRoute: SignInRoute,SignOutRoute: SignOutRoute,AuthConfirmRoute: AuthConfirmRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)